
export default {
  selectBoardList: { // 게시판 조회
    method: 'GET',
    url: 'mrm/v1/anonym/nrw/board/boardList'
  },
  selectBoardDetail: { // 게시판 상세
    method: 'GET',
    url: 'mrm/v1/anonym/nrw/board/boardDetail'
  },
  selectBoardAgrmtTgtAgrYn: { // 게시글 이벤트 동의여부 조회
    method: 'GET',
    url: 'mrm/v1/permit/board/boardDetail/boardAgrmtTgtAgrYn'
  },
  saveTermsAgrmt: { // 이벤트 동의 저장
    method: 'POST',
    url: 'mrm/v1/permit/board/boardDetail/saveTermsAgrmt'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/boardApi.js